import React from 'react'
import Navbar from './Navbar'
import Topbar from './Topbar'

export default function index() {
  return (
    <>
    <Topbar/>
    <Navbar/>
    </>
  )
}
